var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Select2',{staticClass:"default-style",attrs:{"options":_vm.companiesOptions,"placeholder":"Buscar empresa","selectedOption":_vm.selectedCompany,"filterable":false},on:{"input":_vm.selectCompany,"search":_vm.searchCompanies}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }